import * as React from 'react';

import FiltersContainerView from 'filters-container.view';
import { CalendarDeviceMode, ICalendarSettings} from '../../classes/calendar';
import { ICalendarAppText } from '../../custom/classes/calendar-text';

import { ICalendarAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';

import A11yDialog = require('a11y-dialog');

interface StateToProps {
    text: ICalendarAppText;
    deviceMode: CalendarDeviceMode;
    filtersAlwaysModal: boolean;
}

interface ModalControlMethods {
    showModal: () => void;
    hideModal: () => void;
}

export type FiltersContainerProps = StateToProps;
export type FiltersContainerViewProps = FiltersContainerProps & ModalControlMethods;

export class FiltersContainerBase extends React.Component<FiltersContainerProps, null> implements ModalControlMethods {
    private dialog;

    constructor(props: FiltersContainerProps) {
        super(props);
    }

    initializeModal() {

        if (this.dialog) {
            this.dialog.create();
        } else {
            const element = findDOMNode(this);
            this.dialog = new A11yDialog(element);
        }
    }

    destroyModal() {
        if (this.dialog) {
            // Hide the dialog, then unbind all listeners and finally set to null.
            this.dialog.destroy();
        }
    }

    componentDidMount() {
        if (this.props.deviceMode === CalendarDeviceMode.MOBILE || this.props.filtersAlwaysModal) {
            this.initializeModal();
        }
    }

    componentDidUpdate(prevProps: FiltersContainerProps) {
        if (!this.props.filtersAlwaysModal) {
            switch (this.props.deviceMode) {
                case CalendarDeviceMode.MOBILE: {
                    this.initializeModal();
                    break;
                }
                default: {
                    this.destroyModal();
                }
            }
        }
    }

    componentWillUnmount() {
        this.destroyModal();
    }

    showModal() {
        if (this.dialog) {
            this.dialog.show();
        }
    }

    hideModal() {
        if (this.dialog) {
            this.dialog.hide();
        }
    }

    render() {
        return <FiltersContainerView {...this.props} showModal={this.showModal.bind(this)} hideModal={this.hideModal.bind(this)} />;
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        text: state.calendarText,
        deviceMode: state.calendarSettings.calendarDeviceMode,
        filtersAlwaysModal: state.calendarSettings.filtersAlwaysModal
    }
}

export default connect(mapStateToProps)(FiltersContainerBase);